import React from 'react';
import { graphql, Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import SEO from '../components/SEO';
import Layout from '../components/Layout';
import Hero from '../components/Hero';

import '../css/pages/_blog-page.scss';

export default function Blog({ data }) {
  const posts = data.allSanityPost.nodes;

  return (
    <Layout>
      <SEO title="Blog" description="News, guides and insights from Connect Cayman." />

      <div className="blog-page">
        {/* Hero section */}
        <Hero
          h1="Blog"
          p="News, guides and insights on smart automation in the Cayman Islands."
        />

        {/* Posts listing */}
        <section className="all-posts">
          <div className="wrapper">
            {posts.length === 0 && (
              <p className="no-posts">No posts yet — check back soon.</p>
            )}

            <div className="posts-grid">
              {posts.map((post) => (
                <Link
                  to={`/blog/${post.slug.current}`}
                  className="post-card"
                  key={post.slug.current}
                >
                  <div className="thumb">
                    {post.thumbnail && post.thumbnail.asset ? (
                      <GatsbyImage
                        image={post.thumbnail.asset.gatsbyImageData}
                        alt={post.thumbnail.alt || post.title}
                        className="img"
                      />
                    ) : (
                      <div className="thumb-placeholder" />
                    )}
                  </div>
                  <div className="content">
                    <h3>{post.title}</h3>
                    <p>{post.excerpt}</p>
                    <span className="read-more">Read more →</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
}

export const query = graphql`
  {
    allSanityPost(sort: { fields: publishedAt, order: DESC }) {
      nodes {
        title
        publishedAt
        excerpt
        slug {
          current
        }
        thumbnail {
          alt
          asset {
            gatsbyImageData(width: 600, placeholder: BLURRED)
          }
        }
      }
    }
  }
`;
